/* istanbul ignore file */
import { useLedgerUrl } from 'domain/shared/ledger';
import { LinkButton, LinkButtonProps } from 'framework/ui/ui-builder';

const ViewLedgerButton = (props: Omit<LinkButtonProps, 'url'>) => {
  const { getSingleEntityUrl } = useLedgerUrl();

  return (
    <LinkButton
      url={id => getSingleEntityUrl(String(id).replace(/[/]/g, '_'))}
      key="view-ledger"
      variant="outlined"
      {...props}
    >
      View
    </LinkButton>
  );
};

export default ViewLedgerButton;
